import { useInputHelper } from 'framework/form';
import useCareerDevelopmentReviewService from 'domain/people/career/development/shared/careerDevelopmentReviewService';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useEffect, useState } from 'react';
import { useDateService } from 'framework/utils';

const useEarlyStartedIntitialization = () => {
  const { initializeValue } = useInputHelper({ source: 'isEarlyStarted' });
  const [isEarlyStarted, setIsEarlyStarted] = useState(false);
  const [nextReviewDate, setNextReviewDate] = useState('');

  const { getToday } = useDateService();
  const { getCareerDevelopmentNextReviewDate } = useCareerDevelopmentReviewService();
  const { getUserAlias } = useAuthenticatedUserService();

  useEffect(() => {
    (async () => {
      const userAlias = await getUserAlias();
      const foundReviewDate = await getCareerDevelopmentNextReviewDate(userAlias || '');
      const earlyStarted = getToday().isBefore(foundReviewDate.date, 'day');

      initializeValue(earlyStarted);
      setIsEarlyStarted(earlyStarted);
      setNextReviewDate(foundReviewDate.date);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isEarlyStarted, nextReviewDate };
};

export default useEarlyStartedIntitialization;
